import React, { useState } from "react";

const GenerateQRPage = () => {
  const [productId, setProductId] = useState("");
  const [badgeNumber, setBadgeNumber] = useState(""); // Added state for badge number
  const [beverageType, setBeverageType] = useState(""); // Added state for beverage type
  const [qrCode, setQrCode] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!productId || !beverageType) {
      alert("Product ID and Beverage Type are required!");
      return;
    }

    try {
      const response = await fetch("https://prophel.in/generate-qr", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          productId,
          beverageType, // Include beverageType in the payload
          baseUrl: `https://prophel.in`,
          batchNumber: badgeNumber, // Include badgeNumber in the payload
        }).toString(),
      });

      const data = await response.json();
      if (response.ok) {
        setQrCode(data.qrCode); // The PHP API should return the QR code URL
      } else {
        alert(data.message || "Something went wrong!");
      }
    } catch (err) {
      console.error("Error:", err);
      alert("Failed to generate QR code.");
    }
  };

  return (
    <div className="p-4 max-w-md mx-auto">
      <h1 className="text-2xl font-bold mb-4">Generate QR Code</h1>
      <form onSubmit={handleSubmit} className="space-y-4">
        <label className="block">
          <span className="text-gray-700">Product ID:</span>
          <input
            type="text"
            value={productId}
            onChange={(e) => setProductId(e.target.value)}
            className="border p-2 rounded w-full mt-1"
            placeholder="Enter Product ID"
            required
          />
        </label>

        <label className="block">
          <span className="text-gray-700">Beverage Type:</span>
          <select
            value={beverageType}
            onChange={(e) => setBeverageType(e.target.value)}
            className="border p-2 rounded w-full mt-1"
            required
          >
            <option value="" disabled>
              Select a beverage type
            </option>
            <option value="rice beer">Rice Beer</option>
            <option value="wheat beer">Wheat Beer</option>
            <optgroup label="Soft Drinks">
              <option value="pineapple tepache">Pineapple Tepache</option>
              <option value="coconut water">Fermanted Coconut water</option>
            </optgroup>
          </select>
        </label>

        <label className="block">
          <span className="text-gray-700">Badge Number:</span>
          <input
            type="text"
            value={badgeNumber}
            onChange={(e) => setBadgeNumber(e.target.value)}
            className="border p-2 rounded w-full mt-1"
            placeholder="Enter Badge Number"
            required
          />
        </label>

        <button
          type="submit"
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        >
          Generate QR
        </button>
      </form>

      {qrCode && (
        <div className="mt-6">
          <h2 className="text-xl font-semibold">Generated QR Code:</h2>
          <img src={qrCode} alt="QR Code" className="mt-4 border rounded" />
        </div>
      )}
    </div>
  );
};

export default GenerateQRPage;
